/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormAdjustment } from '../models/FormAdjustment';
import type { FormMessage } from '../models/FormMessage';
import type { FormWaiverUrl } from '../models/FormWaiverUrl';
import type { OpenApiInteger } from '../models/OpenApiInteger';
import type { ParticipantGroupCount } from '../models/ParticipantGroupCount';
import type { RegistrationForm } from '../models/RegistrationForm';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FormsService {

    /**
     * @param id
     * @param waiverId
     * @returns FormWaiverUrl Success
     * @throws ApiError
     */
    public static geFormWaiverDownloadUrl(
        id: OpenApiInteger,
        waiverId: OpenApiInteger,
    ): CancelablePromise<FormWaiverUrl> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/registration-forms/{id}/waivers/{waiverId}/download-url',
            path: {
                'id': id,
                'waiverId': waiverId,
            },
        });
    }

    /**
     * @param id
     * @returns FormMessage Success
     * @throws ApiError
     */
    public static getConfirmationMessage(
        id: OpenApiInteger,
    ): CancelablePromise<FormMessage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/registration-forms/{id}/message',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id
     * @returns ParticipantGroupCount Success
     * @throws ApiError
     */
    public static getCapacityCounts(
        id: OpenApiInteger,
    ): CancelablePromise<Array<ParticipantGroupCount>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/registration-forms/{id}/capacity-counts',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @param id
     * @param couponCode
     * @returns FormAdjustment Success
     * @throws ApiError
     */
    public static getFormAdjustmentByCouponCode(
        id: OpenApiInteger,
        couponCode: string,
    ): CancelablePromise<FormAdjustment> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/registration-forms/{id}/adjustments/{couponCode}',
            path: {
                'id': id,
                'couponCode': couponCode,
            },
        });
    }

    /**
     * @param id
     * @returns RegistrationForm Success
     * @throws ApiError
     */
    public static getForm(
        id: OpenApiInteger,
    ): CancelablePromise<RegistrationForm> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/registration-forms/{id}',
            path: {
                'id': id,
            },
        });
    }

}
